import React, { useState } from "react";
import { Link, NavLink, replace, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import image from "../assets/logodevuong.png";
import { roomOptions } from "./BookingForm";
import { Dropdown, Select, Space } from "antd";

const HeaderAndSubNav = ({ isScrolled }) => {
  const [isSubNavOpen, setIsSubNavOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [changeI18, setChangeI18] = useState(1);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const toggleSubNav = () => {
    setTimeout(() => {
      setIsSubNavOpen(!isSubNavOpen);
      setIsSubMenuOpen(false);
    }, 100);
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };
  const handleLanguageChange = (value) => {
    setChangeI18(value);
    if (Number(value) === 1) {
      i18n.changeLanguage("vi");
    } else if (Number(value) === 2) {
      i18n.changeLanguage("en");
    }
  };
  const items = [
    {
      key: 1,
      label: (
        <span className="flex flex-row items-center">
          {" "}
          <img
            src="https://nhatnguyenhotel.vn/wp-content/plugins/gtranslate/flags/svg/vi.svg"
            alt="VI Flag"
            className="w-5 h-5 mr-1"
          />{" "}
          <p>Việt Nam</p>
        </span>
      ),
    },
    {
      key: 2,
      label: (
        <span className="flex flex-row items-center">
          <img
            src="https://nhatnguyenhotel.vn/wp-content/plugins/gtranslate/flags/svg/en.svg"
            alt="EN Flag"
            className="w-5 h-5 mr-1"
          />{" "}
          <p>English</p>
        </span>
      ),
    },
  ];
  return (
    <div className="xl:max-w-[1450px] mx-auto mt-[130px] uppercase font-normal text-[#A0A0A0] font-cormorant">
      <div className="top-0 left-0 right-0 fixed z-50">
        {/* Header Section */}
        <div className="bg-[#00264D]">
          <header className="xl:max-w-[1450px] m-auto text-white  px-6 flex justify-between items-center flex-wrap">
            <div className="md:hidden flex items-center relative">
              <button
                onClick={toggleSubNav}
                className="text-white focus:outline-none relative w-6 h-6"
              >
                {/* Icon Menu */}
                <svg
                  className={`absolute top-0 left-0 w-6 h-6 transition-transform duration-300 ${
                    isSubNavOpen
                      ? "opacity-0 scale-90"
                      : "opacity-100 scale-100"
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                </svg>
                {/* Icon Close */}
                <svg
                  className={`absolute top-0 left-0 w-6 h-6 transition-transform duration-300 ${
                    isSubNavOpen
                      ? "opacity-100 scale-100"
                      : "opacity-0 scale-90"
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <a
              href="/"
              className={`flex items-center duration-300 ${
                isScrolled ? "activeHeader" : ""
              }`}
            >
              <img
                src={image}
                alt="Logo"
                className="w-16 h-16  border-black rounded"
              />{" "}
              {/* Thêm drop-shadow-md và viền đen */}
            </a>
            <div className="flex items-center space-x-4 sub_nav_css py-4">
              <div className="hidden md:flex items-center space-x-2">
                <Dropdown
                  menu={{
                    items,
                    onClick: (value) => handleLanguageChange(value.key),
                  }}
                >
                  <div
                    className="cursor-pointer"
                    onClick={(e) => e.preventDefault()}
                  >
                    {Number(changeI18) === 1 ? (
                      <span className="flex items-center">
                        <img
                          src="https://nhatnguyenhotel.vn/wp-content/plugins/gtranslate/flags/svg/vi.svg"
                          alt="VI Flag"
                          className="w-12 h-6 mr-1 rounded-[15%]"
                        />
                      </span>
                    ) : (
                      <span className="flex items-center">
                        <img
                          src="https://nhatnguyenhotel.vn/wp-content/plugins/gtranslate/flags/svg/en.svg"
                          alt="EN Flag"
                          className="w-12 h-6 mr-1 rounded-[15%]"
                        />
                      </span>
                    )}
                  </div>
                </Dropdown>
              </div>
              <NavLink
                to="/promotions"
                className="bg-[#D4AF37] w-[170px] text-center text-black px-4 py-2 rounded hover:bg-yellow-600 lg:block ssx:hidden"
              >
                {t("BOOK_NOW")}
              </NavLink>
            </div>
          </header>
        </div>
        <div
          className={`bg-gray-200 ${isSubNavOpen ? "" : "md:block ssx:hidden"}`}
        >
          <nav className="xl:max-w-[1450px] m-auto py-4 px-6">
            {isSubNavOpen && (
              <li className="md:hidden flex justify-center space-x-4">
                <button
                  onClick={() => changeLanguage("en")}
                  className="flex items-center"
                >
                  <img
                    src="https://nhatnguyenhotel.vn/wp-content/plugins/gtranslate/flags/svg/en.svg"
                    alt="EN Flag"
                    className="w-5 h-5 mr-1"
                  />
                  <span>EN</span>
                </button>
                <button
                  onClick={() => changeLanguage("vi")}
                  className="flex items-center"
                >
                  <img
                    src="https://nhatnguyenhotel.vn/wp-content/plugins/gtranslate/flags/svg/vi.svg"
                    alt="VI Flag"
                    className="w-5 h-5 mr-1"
                  />
                  <span>VI</span>
                </button>
              </li>
            )}
            <ul
              className={`${
                isSubNavOpen ? "flex" : "hidden"
              } md:flex max-sm:mt-[10px] flex-col md:flex-row md:justify-center md:space-x-6 space-y-4 md:space-y-0 text-center text-black`}
            >
              <li>
                <NavLink
                  to="/"
                  onClick={toggleSubNav}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#D4AF37] hover:text-yellow-300"
                      : "hover:text-gray-700"
                  }
                >
                  {t("HOME")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/about"
                  onClick={toggleSubNav}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#D4AF37] hover:text-yellow-300"
                      : "hover:text-gray-700"
                  }
                >
                  {t("ABOUT_US")}
                </NavLink>
              </li>
              {/* desktop */}
              <li className="relative group lg:block ssx:hidden">
                <NavLink
                  to="/rooms"
                  onClick={toggleSubNav}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#D4AF37] hover:text-yellow-300 flex justify-center items-center w-full text-left"
                      : "hover:text-gray-700 flex justify-center items-center w-full text-left"
                  }
                >
                  {t("ROOMS_AND_RATES")}
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </NavLink>
                <ul
                  className={`${
                    isSubNavOpen ? "block" : "hidden"
                  } md:block dropdown text-left lg:block `}
                >
                  <div className="absolute top-[-10px] left-1/2 transform -translate-x-1/2 md:left-6 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-white"></div>
                  {roomOptions.map((option, index) => (
                    <li key={index}>
                      <NavLink
                        to={{
                          pathname: "/rooms/detail-rooms",
                          search: `${index + 1}`,
                        }}
                        className={() =>
                          location.pathname === `/rooms/detail-rooms` &&
                          location.search === `?${index + 1}`
                            ? "text-[#D4AF37] bg-gray-100 block px-4 py-2 hover:bg-gray-200 rounded"
                            : "block px-4 py-2 hover:bg-gray-100 rounded"
                        }
                      >
                        {t(option.label)}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
              {/* mobile */}
              <li className="groupSub lg:hidden ssx:block">
                <div
                  onClick={toggleSubMenu}
                  className="flex flex-row justify-center items-center w-full text-left cursor-pointer"
                >
                  {t("ROOMS_AND_RATES")}
                  <svg
                    className={`w-4 h-4 ml-1 transition-transform duration-300 ${
                      isSubMenuOpen ? "rotate-180" : "rotate-0"
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                <ul
                  className={`dropdownSub ${
                    isSubMenuOpen === false ? "" : "active"
                  }`}
                >
                  {roomOptions.map((option, index) => (
                    <li key={index}>
                      <NavLink
                        to={{
                          pathname: "/rooms/detail-rooms",
                          search: `${index + 1}`,
                        }}
                        onClick={toggleSubNav}
                        className={() =>
                          location.pathname === `/rooms/detail-rooms` &&
                          location.search === `?${index + 1}`
                            ? "text-[#D4AF37] bg-gray-100 block px-4 py-2 hover:bg-gray-200 rounded"
                            : "block px-4 py-2 hover:bg-gray-100 rounded"
                        }
                      >
                        {t(option.label)}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <NavLink
                  to="/promotions"
                  onClick={toggleSubNav}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#D4AF37] hover:text-yellow-300"
                      : "hover:text-gray-700"
                  }
                >
                  {t("PROMOTIONS")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/gallery"
                  onClick={toggleSubNav}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#D4AF37] hover:text-yellow-300"
                      : "hover:text-gray-700"
                  }
                >
                  {t("GALLERY")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  onClick={toggleSubNav}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#D4AF37] hover:text-yellow-300"
                      : "hover:text-gray-700"
                  }
                >
                  {t("CONTACT")}
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default HeaderAndSubNav;
